const Info = [
    {
        id: 1, img: "./images/user.jpg", name: "Member 1", position: "Frontend", phone: "+4913092404820", email: "member@gmail.com", ort: "Berlin",
    },
    {
        id: 2, img: "./images/user.jpg", name: "Member 2", position: "Full Stack", phone: "+4913092404820", email: "member@gmail.com", ort: "Munich", website: "www.member.com"
    },
    {
        id: 3, img: "./images/user.jpg", name: "Member 3", position: "Backend", phone: "+4913092404820", email: "member@gmail.com", ort: "Cologne",
    },
    {
        id: 4, img: "./images/user.jpg", name: "Member 4", position: "Full Stack", phone: "+4913092404820", email: "member@gmail.com", ort: "Stuttgart", website: "www.member.com"
    },
    {
        id: 5, img: "./images/user.jpg", name: "Member 5", position: "Backend", phone: "+4913092404820", email: "member@gmail.com", ort: "Bremen"
    },
    {
        id: 6, img: "./images/user.jpg", name: "Member 6", position: "Frontend", phone: "+4913092404820", ort: "Köln", email: "member@gmail.com", website: "www.member.com"
    },
    {
        id: 7, img: "./images/user.jpg", name: "Member 7", position: "Full Stack", phone: "+4913092404820", email: "member@gmail.com", ort: "Hamburg"
    },
    {
        id: 8, img: "./images/user.jpg", name: "Member 8", position: "Frontend", phone: "+4913092404820", email: "member@gmail.com", ort: "Dresden", website: "www.member.com"
    },
    {
        id: 9, img: "./images/user.jpg", name: "Member 9", position: "Backend", phone: "+4913092404820", email: "member@gmail.com", ort: "Dortmond",
    },
];

export default Info;
